var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { useSimpleModal } from "hx-ui";
export function useStyledModal(_a) {
    var content = _a.content, header = _a.header, buttonProps = _a.buttonProps;
    var _b = useSimpleModal(_jsxs("div", __assign({ className: "flex flex-col items-center text-center gap-8" }, { children: [_jsx(Typography, __assign({ variant: "h5", className: 'text-charcoal text-xl md:text-3xl font-extrabold' }, { children: header })), content] })), {
        buttonProps: __assign({ className: 'bg-primary py-2 md:w-full md:max-w-[200px]', text: 'Close' }, buttonProps),
        modalProps: {
            className: 'gap-0 pt-8 pb-12 w-full max-w-[85%] lg:max-w-2xl'
        }
    }), styledModal = _b[0], toggleStyledModal = _b[1];
    return { styledModal: styledModal, toggleStyledModal: toggleStyledModal };
}
